import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function EditArea() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const [member, setMember] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  const memberId = location.pathname.split('/')[2];

  const handleChange = (e) => {
    setMember((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        'https://databasebackend.ecz.co.zw/areas/' + memberId,
        member
      );
      toast('Area has been succesfully updated');
      navigate('/areas');
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const fetchAllMembers = async () => {
      try {
        const res = await axios.get(
          `https://databasebackend.ecz.co.zw/areas/${memberId}`
        );
        setMember(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAllMembers();
  }, [memberId]);

  return (
    <div className="member">
      <div className="memberTitleContainer">
        <h1 className="memberTitle">Edit Area Details</h1>
      </div>
      <div className="memberContainer">
        <div className="memberUpdate">
          <form action="">
            <div className="form-body">
              <h3 className="box-title">Area Details</h3>
              <hr />
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">Area Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={member.area}
                      onChange={handleChange}
                      name="area"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-actions">
              <button className="btn btn-success" onClick={handleClick}>
                {' '}
                Update
              </button>
              <Link to="/areas">
                <button className="btn btn-cancel"> Cancel</button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
